import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AlertMessageService } from "@bundle/component/alert-message/alert-message.service";
import { AppMs13Service } from "app/business/service/app/app-ms13.service";
import { map, Observable, startWith } from "rxjs";

@Component({
  selector: "app-add-surveyor-report-modal",
  templateUrl: "./add-surveyor-report-modal.component.html",
  styleUrls: ["./add-surveyor-report-modal.component.css"],
})
export class AddSurveyorReportModalComponent implements OnInit {
  form: any = {};
  selectedData: any = {};
  inspectPetitionNumberSearch = new FormControl();
  filteredOptionsInspectPetitionNumber$: Observable<string[]>;
  inspectPetitionNumberList: any = [];
  userProfile: any = JSON.parse(localStorage.getItem("userProfile"));
  selectedItem: boolean = false;

  constructor(
    private appMs13Service: AppMs13Service,
    private alertMessageService: AlertMessageService,
    private dialogRef: MatDialogRef<AddSurveyorReportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = data;
  }

  async ngOnInit() {
    var request = {
      ms13HId: this.form.id
    }

    await this.appMs13Service.getMs13SurveyorInspectionListExternal(request).then(res => {
      if (res.length == 0) {
        this.inspectPetitionNumberList = [];
        this.inspectPetitionNumberList.push({
          ocsTccInspectionId: 0,
          inspectionNumber: "ไม่พบเลขที่แจ้งงานตรวจปล่อยสินค้า"
        })
      } else {
        this.inspectPetitionNumberList = res;
      }
    })

    this.filteredOptionsInspectPetitionNumber$ =
      this.inspectPetitionNumberSearch.valueChanges.pipe(
        startWith(""),
        map((value) => {
          const name = typeof value === "string" ? value : value?.name;
          return name
            ? this.filterSurveyInspection(name as string)
            : this.inspectPetitionNumberList.slice();
        })
      );
  }

  filterSurveyInspection(name: string) {
    console.log(name);
    const filterValue = name.toLowerCase();

    return this.inspectPetitionNumberList.filter(function (option) {
      if (option.inspectionNumber.includes(filterValue)) {
        return option;
      }
    });
  }

  displayInspectionNumber(inspect): string {
    return inspect && inspect.inspectionNumber
      ? `${inspect.inspectionNumber}`
      : "";
  }

  selectionInspectionNumber(e): void {
    if (e.option.value.ocsTccInspectionId === 0) {
      return;
    }

    this.selectedData = e.option.value;

    this.selectedData.inspectionDate = new Date(this.selectedData.startDateTime);

    this.selectedItem = true;
  }

  cancelItem() {
    this.inspectPetitionNumberSearch.setValue("");
    this.selectedData = {};
    this.selectedItem = false;
  }

  checkOptionValue(e) {
    if (typeof e === "object") {
      return e?.surveyLocationName;
    } else {
      return e;
    }
  }

  endPopup(e) {
    if (e == "save") {
      if (!this.selectedItem) {
        this.alertMessageService.open({
          message: "กรุณาเลือกเลขที่แจ้งงานตรวจปล่อยสินค้าก่อนการบันทึกรายงาน",
          title: ""
        })
      } else {
        this.dialogRef.close(this.selectedData);
      }
    } else {
      this.dialogRef.close(undefined);
    }
  }
}
